<ui-badge
  [tooltip]="name()"
  [variant]="variant()"
  [appearance]="appearance()"
  [preventNumericDisplay]="true"
  [value]="value()"
  justifySelf="start" />
